import React from "react";

interface ModalHeaderProps {
  title: string;
  // 오른쪽 끝에 배치할 임의의 컴포넌트 (체크박스, 버튼 등)
  rightComponent?: React.ReactNode;
  // rightComponent 오른쪽에 붙는 라벨 (문자열 또는 노드)
  rightLabel?: React.ReactNode;
  // 라벨과 컴포넌트 컨테이너에 커스텀 클래스 적용
  rightContainerClassName?: string;
  // 라벨을 특정 input과 연결하고 싶을 때 htmlFor 지정 (선택)
  rightLabelFor?: string;
}

export default function ModalHeader({
  title,
  rightComponent,
  rightLabel,
  rightContainerClassName = "",
  rightLabelFor,
}: ModalHeaderProps) {
  const hasRight = rightComponent != null || rightLabel != null;

  return (
    <div className="border-b border-[#333333] mb-4">
      <div className="flex items-center justify-between">
        <div className="flex justify-start">
          <p className="text-lg font-semibold text-[#333333] mb-[6px] bg-[#D0E7AC] px-2 ">{title}</p>
        </div>

        {hasRight && (
          <div className={`ml-4 flex items-center gap-2 ${rightContainerClassName}`}>
            {rightComponent}
            {rightLabel != null &&
              (rightLabelFor ? (
                <label htmlFor={rightLabelFor} className="text-sm text-[#333333] select-none cursor-pointer">
                  {rightLabel}
                </label>
              ) : (
                <span className="text-sm text-[#333333] select-none">{rightLabel}</span>
              ))}
          </div>
        )}
      </div>
    </div>
  );
}
